import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from "@chakra-ui/react";
import React from "react";
import TwilioSettings from "./TwilioSettings";
import KnowledgeBaseSettings from "./KnowledgeBaseSettings";

interface CommunitySettingsModalProps {
  isOpen: boolean;
  onClose: () => void;
  communityId: string;
  phoneNumber?: string;
}

export default function CommunitySettingsModal({
  isOpen,
  onClose,
  communityId,
  phoneNumber,
}: CommunitySettingsModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Community Settings</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Tabs isFitted variant="enclosed">
            <TabList mb="1em">
              <Tab>Twilio Configuration</Tab>
              <Tab>Knowledge Base</Tab>
            </TabList>
            <TabPanels>
              <TabPanel>
                <TwilioSettings
                  communityId={communityId}
                  currentPhoneNumber={phoneNumber}
                />
              </TabPanel>
              <TabPanel>
                <KnowledgeBaseSettings communityId={communityId} />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </ModalBody>
        <ModalFooter>
          <Button onClick={onClose}>Close</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
